import { PackageProviderName } from 'data/ppoints/constants';
import { AggregatorPackageProvider } from 'models/ppoints/CountryWithAggregatedProviders';
import { PackageProvider } from 'models/ppoints/PackageProvider';
import { Aggregator } from '../../../../pb/aggregators/v1/aggregator_pb';
import { AggregatorsResponse_Aggregator } from '../../../../pb/responses/v1/aggregators_response_pb';

/**
 * Maps an aggregator to a provider-shaped stand-in so it renders through the same provider cards
 * as a standalone provider. Aggregator enum keys (e.g. KVIKK) already match PackageProviderName
 * values (e.g. 'kvikk') by naming convention — see useProviderAggregator for the same mapping.
 *
 * Takes on the id of the first of its own carriers rather than the aggregator's own id, so it
 * resolves to a real package-provider id — the one `usePPointsFeatures`/`getProviderFeatures`
 * already knows how to look features up by.
 */
export const mapAggregatorToProvider = (
    aggregator: AggregatorsResponse_Aggregator,
    providers: PackageProvider[]
): AggregatorPackageProvider => ({
    id: providers[0].id,
    name: Aggregator[aggregator.name]?.toLowerCase() as PackageProviderName,
    enabled: true,
    countries: [],
    aggregator_id: null,
    aggregator,
    providers,
});
